module.exports = __webpack_public_path__ + "img/Tailgater-Pro.c22e6ac4.png";